export default "__VITE_ASSET__SmcE4rL6__"